import Gift from './Gift';

export default Gift;
